import React from 'react';
import { Button, Form, FormGroup, Input, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DeleteButton from 'components/buttons/DeleteButton';

const DynamicForm = ({value, onChange}) => {
    console.log('Dynamic Form')
    console.log(value)

    const handleInputChange = (index, event) => {
        const values = [...value];
        values[index][event.target.name] = event.target.value;
        onChange({target: {id: 'target_fields', value: values}});
    };

    const handleAddClick = () => {
        
        const values = [...value ? value : [], { key: Date.now(), value1: '', value2: '' }];
        onChange({target: {id: 'target_fields', value: values}});
    };

    const handleRemoveClick = index => {
        const values = [...value];
        values.splice(index, 1);
        onChange({target: {id: 'target_fields', value: values}});
    };

    return (
        <Form>
            {value && value.map((input, index) => (
                <FormGroup key={input.key}>
                    <Row>
                        <Col md={3}>
                            <Input
                                type="text"
                                name="value1"
                                value={input.value1}
                                onChange={(event) => handleInputChange(index, event)}
                            />
                        </Col>
                        <Col md={7}>
                            <Input
                                type="text"
                                name="value2"
                                value={input.value2}
                                onChange={(event) => handleInputChange(index, event)}
                            />
                        </Col>
                        <Col md={2}>
                            <DeleteButton deleteItem={handleRemoveClick} id={index}/>
                        </Col>
                    </Row>
                </FormGroup>
            ))}
            <Col md={1}>
                <Button className="btn" color="secondary" onClick={handleAddClick}>
                    <FontAwesomeIcon icon={faPlus} size="lg" />
                </Button>
            </Col>

        </Form>
    );
};

export default DynamicForm;
